export class PROPERTIES {
  public static Kerimissuund = '26d2ad73-a6be-4b46-bd6a-bda9b45df23f';
  public static Fotosilm = 'fae07251-e8f4-46a6-bdc8-190a1f3c6e8c';
  public static BomCalculation = 'bde0beef-1e33-4145-84cb-4c48d0fbf0e4';
  public static Width = '6a43642a-2e71-44bd-b618-9da11ce5b97e';
  public static ConfigurationEditor = '3f5794e9-638a-4941-b450-3f65a4d7634c';
  public static Todo = 'fc6a2958-beac-42fa-b7e1-f2129e89eb97';
  public static Bag = '2682a643-31e2-40e8-b96b-4d26530a215d';
  public static PieceBag = 'bae97f4c-5188-4a1a-b275-e21f94effc4f';
  public static WeldingMethod = 'f7b40254-9cde-4051-b658-c47f355fbdfb';
  public static KotisuuAsukoht = '54b3d82d-f995-4011-8f6b-972f9ff7362a';
  public static KaeavaPaigutus = 'e006d031-0b30-4ba6-8844-0176af14e580';
  public static KileTyyp = '1161622e-665f-4d87-9ea7-0dd3c8761c38';
  public static DesignPlacementInFront = '66565cc0-e28f-4a00-8e1a-2abd6cd000d9';
  public static ColorCount = 'b043160a-13d0-4740-a8e9-b44bc6426d56';
  public static ColorRecipe = '967c0c63-5ef0-4c62-b506-d30369afd3c7';
  public static Anilox = 'ce4422de-6c92-4f61-838e-add86b987bbe';
  public static ProofingOrderFile = '616b2a23-df9e-4c31-932b-cb5e5ebaba20';
  public static PlateOrderFile = '0796f754-2d30-434f-a93d-1a11fb3a0e01';
  public static AstmeteArv = '7e9439a0-621c-476c-a14b-99bdcd23f01f';
  public static TrykiplaadiPaksus = 'a5dfcd5f-3754-4851-b1c5-441bbd6c77b8';
  public static PreCutting1 = 'b0ee6c8d-3181-4504-a222-705cf651755c';
  public static PreCutting2 = '85f1e095-5c6a-4b83-a8ba-a8ce08f34d66';
  public static OrderLinesListFilterSettings = '7abd0240-a103-4fdf-ab27-7ab999d9b120';
  public static Taispinnavoll = 'd79d735f-3320-46fb-a8e2-2bab82cf86f6';
  public static Kylg = '691da0ff-9ed6-4fa1-93ee-55a7ce3d352f';
  public static Lpi = 'ec534d32-413f-4f09-a393-f649bee41e7b';
  public static ColorMark = '62d713c6-b997-4af0-916b-78df72bec37f';
  public static Paigaldusteip = '260487d5-5b20-471d-b720-5b1eb5f4b4f6';
  public static Blocked = '75912828-e29d-40c4-990d-c33ec37275c2';
  public static DisainiProtsess = 'f90735dc-63e6-4a65-b0ff-9e3051ed65bc';
  public static KileMaterjal = '9b41cf42-668a-4084-b7eb-78dabf388dbe';
  public static Thickness = '5cf8cfe7-94aa-4d64-97fa-445549c97417';
  public static Comment = '3893cf1d-c33b-486c-b052-bc960e2f35b5';
  public static Lahtematerjal = '88b54cd5-1c49-4127-9a89-5c84e96cd28d';
  public static BaseRecipe = '0af71693-94b0-48a0-93fe-0bf3f46af81c';
  public static QtyOfShafts = 'cfaaeea8-242d-4974-8d4a-0a79b724b3fc';
  public static Trykimasin = '11b9c548-e0b9-4a57-a49f-e3690ad20fb2';
  public static Pouch = '35f33f88-0685-4f61-a54e-030707c51baa';
  public static QuestionPrint = '99cf6239-97cb-4a2a-9093-43f6f9d00a82';
  public static QuestionWelding = 'ca16395a-fae2-4e0b-95bc-fae72ee53e8b';
  public static PooltooteKood = '7cc55df5-76bd-4596-a435-923a4711b524';
  public static KlientViibibTrykiJuures = 'f9a4965d-af40-401f-959d-191dd1d752ba';
  public static EanKohustuslik = 'abafac0b-86ac-465d-8c4e-636e59b19be5';
  public static Ean = 'de19b0df-fdd3-4d4b-883c-6a22e923151a';
  public static ContractInProgress = '50fb7c21-c199-4179-b2c9-f3fdd94f63d6';
  public static NextProductionOrder = 'f62478dd-3415-43dc-82af-1b3e76984c32';
  public static QuestionLayerCount = '0fd8c142-c2bd-44c2-9c24-c1b49a152257';
  public static KaardiAsukoht = '742241e4-50d6-40fd-a5f9-effd939f5cb1';
  public static OutputCount = 'bb2a4206-d6d2-46a0-8a84-5c49922d4d9b';
  public static Version = '6e8cbf1c-4fed-45bd-92ad-7f870ae33f50';
  public static KliendiPlaadid = 'd9a6bda0-067f-4ef5-9edf-93b07b2e58e3';
  public static ProofingOrderCode: string = '348ab1ce-a02f-4652-a3c2-e80db2e9657f';
  public static PlateOrder: string = 'bd9330ec-1cf3-4266-886d-01e268f2de80';
  public static X: string = 'a752ac9c-b16f-432c-883a-afbf4b3006b1';
  public static Y: string = '1000e6b3-b9de-4eb2-a886-8930c3b2360c';
  public static PlaadiAsukoht = '7cc4e278-a38c-41d7-b98e-bce98f3e6afd';
  public static Hankija = 'fa84b175-d92c-4c67-a27d-f92b75a256ec';
  public static ValidationResult = 'd5c00b37-8dad-4269-83fa-0c9a8b908c78';
  public static InfoTrykkijale = '4aaa639b-3c32-479a-956f-4c8ddae48f40';
  public static InfoArvutigraafikule = 'd937103e-dc10-4369-b707-c287104d8ade';
  public static GraphPoint = '08745f2e-cd4b-421c-b568-955fbae8b5f8';
  public static ParentGraphPoint = '13543c40-eff4-49bf-bd55-25a6b5772dbd';
}


